import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors cursor-pointer disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring',
  {
    variants: {
      variant: {
        primary: 'bg-action-primary text-foreground-on-action hover:bg-action-primary-hover',
        secondary:
          'border border-border-default bg-background-elevated text-foreground-primary hover:bg-background-subtle',
        ghost: 'text-foreground-primary hover:bg-background-subtle',
        danger: 'bg-status-danger text-foreground-on-action hover:opacity-90',
      },
      size: {
        sm: 'h-8 px-3 text-sm',
        md: 'h-10 px-4 text-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)
